export default __webpack_public_path__ + "static/media/shadow-hot-autumn.9b6cc017.png";